import { Button } from '@assembly-js/design-system';
import React from 'react';

/**
 * Shared layout chrome for the plan-change modals (upgrade / add-credits
 * confirm — siblings in the Figma frame family 7127:59772): every content
 * section shares the header's horizontal inset, with a consistent vertical
 * rhythm between the cards, footer text, and buttons.
 */
export const PLAN_CHANGE_MODAL_CONTENT_CLASSES =
  'flex flex-col gap-5 px-7 pb-6';

interface PlanChangeModalButtonsProps {
  cancelLabel: string;
  confirmLabel: string;
  isLoading: boolean;
  isConfirmDisabled?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/** The Figma full-width two-button row: Cancel and confirm split the width. */
export const PlanChangeModalButtons: React.FC<PlanChangeModalButtonsProps> = ({
  cancelLabel,
  confirmLabel,
  isLoading,
  isConfirmDisabled = false,
  onCancel,
  onConfirm,
}) => (
  <div className="flex gap-3">
    <Button
      type="button"
      variant="secondary"
      className="flex-1"
      label={cancelLabel}
      disabled={isLoading}
      onClick={onCancel}
    />
    <Button
      type="button"
      variant="primary"
      className="flex-1"
      label={confirmLabel}
      disabled={isConfirmDisabled || isLoading}
      loading={isLoading}
      onClick={onConfirm}
    />
  </div>
);
